<template>
  <v-container fluid class="article-editor px-0 py-0">
    <v-layout row nowrap>
      <v-flex sm8 md9 lg10 class="pr-3 editor-container">
        <CrudRichEditor :content="content" :initConfig="editorCfg" ref="editor"></CrudRichEditor>
        <v-btn color="primary" @click="saveContent" class="save-btn">保存文章</v-btn>
      </v-flex>
      <v-flex sm4 md3 lg2 class="image-group">
        <div>
          <crud-image-field :val="imageField" ref="imageField" :cfg="imageUploadCfg" @change="onUploadImage" />
        </div>
        <v-card v-for="a in attachs" :key="a.name" class="mb-1">
          <v-card-text>
            <img :src="a.url" style="width: 100%;" />
          </v-card-text>
          <v-card-actions>
            <v-btn icon flat @click="addImage(a)">
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-spacer />
            <v-btn icon flat @click="deleteAttach(a)">
              <v-icon>delete</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { CrudRichEditor, CrudImageField } from "javaee-fre";
export default {
  name: "admin-article-editor",
  components: {
    CrudRichEditor,
    CrudImageField
  },
  data() {
    return {
      content: "",
      attachs: [],
      imageField: null,
      editorCfg: {
        language_url: `${process.env.BASE_URL}tinyLanguage/zh_CN.js`,
        language: "zh_CN",
        skin_url: `${process.env.BASE_URL}skins/ui/oxide`,
        height: 400,
        plugins: ["lists"],
        toolbar:
          "undo redo | formatselect | bold italic forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat",
        branding: true,
        menubar: false,
        content_css: `${process.env.BASE_URL}skins/content/default/content.min.css`,
        convert_urls: false,
        relative_urls: false
      }
    };
  },
  props: {
    cfg: Object
  },
  computed: {
    imageUploadCfg() {
      let self = this;
      return {
        _url: "/home/admin/c/article",
        name: "attachs",
        _id: self.cfg.targetId,
        _params: { _attachs: true },
        contentType: "image/*",
        maxCount: 1,
        transform: false
      };
    }
  },
  beforeMount() {
    this.init(this.cfg);
  },
  watch: {
    cfg(val) {
      this.init(val);
    }
  },
  methods: {
    onUploadImage(v) {
      let self = this;

      v = v.split("/")[0];
      self.$axios
        .post(
          `/home/admin/c/article/update/${self.cfg.targetId}`,
          self.$qs.stringify({
            _attachs: true,
            attachs: self.a.attachs ? self.a.attachs + "," + v : v
          })
        )
        .then(() => {
          self.a.attachs = self.a.attachs ? self.a.attachs + "," + v : v;
          self.attachs = self.parseAttachs(self.a.attachs);

          self.imageField = null;
          self.$refs.imageField.init();
        });
    },
    saveContent() {
      let self = this;
      self.$axios
        .post(
          `/home/admin/c/article/update/${self.cfg.targetId}`,
          self.$qs.stringify({ _cedit: true, content: self.$refs.editor.html })
        )
        .then(r => {
          if (r.data && r.data.status == "ok") {
            self.$status("保存成功", "success");
          } else {
            self.$status("保存失败！", "error");
          }
        });
    },
    addImage(a) {
      this.$refs.editor.insertImg(a.url);
    },
    deleteAttach(a) {
      let self = this;
      self.$axios
        .get(`/home/admin/c/article/upload/delete/attachs`, {
          params: { uuid: a.name, __entity_id: self.cfg.targetId }
        })
        .then(() => {
          let attachs = self.a.attachs,
            arr = attachs.split(","),
            idx = arr.findIndex(tmp => tmp == a.name);
          arr.splice(idx, 1);
          attachs = arr.join(",");

          self.a.attachs = attachs;
          self.attachs = self.parseAttachs(attachs);
          self.$axios
            .post(
              `/home/admin/c/article/update/${self.cfg.targetId}`,
              self.$qs.stringify({
                _attachs: true,
                attachs: attachs
              })
            )
            .then(() => { });
        });
    },
    parseAttachs(attachs) {
      let self = this,
        a = self.a,
        tmp = [];

      if (!attachs) {
        return tmp;
      }

      attachs = attachs.split(",");

      for (let att of attachs) {
        if (att.length > 0) {
          tmp.push({
            url: `${self.$const.baseUrl}/home/admin/c/article/img/${a.id}/${att}`,
            name: att
          });
        }
      }
      return tmp.reverse();
    },
    init(cfg) {
      let self = this;
      self.content = "";
      self.$axios
        .get(`/home/admin/c/article/get/${cfg.targetId}`, {
          params: { _cedit: true }
        })
        .then(r => {
          if (r && r.data && r.data.status === "ok") {
            let a = r.data.message;
            self.a = a;
            self.content = a.content;
            self.attachs = self.parseAttachs(a.attachs);
          }
        });
    }
  }
};
</script>

<style scoped>
.image-group {
  overflow: auto;
}
</style>
<style>
.article-editor,
.article-editor .layout,
.article-editor .layout {
  height: 100%;
}

.article-editor .layout .image-group {
  overflow-y: auto;
}

.article-editor .layout .tox-tinymce {
  height: 100% !important;
}

.editor-container {
  display: flex;
  flex-direction: column;
}

.editor-container .save-btn {
  flex-shrink: 0;
  margin-top: 20px;
  width: 200px;
  margin-left: 0;
}
</style>